export const modes = [
  {
    id: 'observation',
    label: 'observation',
    video: 'arcnova-observation-flight',
    title: 'Sensing and interpretation.',
    paragraphs: [
      'Studying how onboard sensing contributes to an understanding of the surrounding environment.',
      'The central questions are what a system can observe, where information is incomplete and how uncertainty should be represented.',
    ],
  },
  {
    id: 'navigation',
    label: 'navigation',
    video: '13504946-uhd_3840_2160_30fps-1',
    title: 'Behaviour in changing conditions.',
    paragraphs: [
      'Examining how autonomous navigation depends on terrain, environmental conditions and available connectivity.',
      'This perspective considers the assumptions behind navigation decisions and how changing conditions expose the limits of a system.',
    ],
  },
  {
    id: 'oversight',
    label: 'oversight',
    video: 'arcnova-overhead-flight',
    title: 'Keeping behaviour understandable.',
    paragraphs: [
      'Studying the relationship between autonomous behaviour and human supervision.',
      'The focus is on making system state, decisions and uncertainty clear to the people overseeing a flight.',
    ],
  },
] as const;
